import type { Scenario } from "@/composables/forms/formTypes";
import type { FormStoreState } from "@/plugins/piniaForm";
import { defineStore } from "pinia";

type ScenarioState = FormStoreState<Scenario>;

export const useScenarioStore = defineStore({
  id: "scenario",
  state: (): ScenarioState => ({
    formData: {} as Scenario,
    initialData: {} as Scenario,
    requiredFields: ["title", "reason"]
  }),
  getters: {
    scenario(): Scenario {
      return this.formData;
    }
  },
  actions: {},
  useForm: true
});
